<template>
    <div class="wrap grey-bg">
        <div class="box1200">
            <div class="index-title">
                <h3 class="title">看看客户说什么</h3>
                <p class="sort-title">来自客户对{{this.$store.state.siteName}}最真实的声音</p>
            </div>
            <!--index-title-->
            <el-carousel indicator-position="outside" trigger="click" arrow="always" height="440px" class="Tbox">
                <el-carousel-item v-for="item in TList" :key="item.id">
                    <div class="Tmain">
                        <p class="pic"><img :src="item.imgUrl"></p>
                        <p class="company">{{item.company}}</p>
                        <p class="content">{{item.content}}</p>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>
<script>
export default {
  name: 'HomeCustomer',
  data () {
    return {
      TList: [
        {id: '0', imgUrl: ('https://img.xiaochengdaren.com/2019092858592.jpg'), name: '', company: '广东帮啦网络技术有限公司', content: '公司致力于为客户提供同城帮买、帮送、帮办服务，基于GPS和地图服务技术，采用就近策略安排跑腿人（10分钟内即可上门)，同城配送30分钟内送达，“专人专送”制度。在跑腿过程中，最重要的就是配送员招收。招收信息发布，我们选择小城达人，进行线上同城精准社群传播推广方式，将招聘信息即时传送，同城500+优质达人微信传播推广，引起同城大量人员需求者关注并报名加入，实力推广，我推荐！小城达人~'},
        {id: '1', imgUrl: ('https://img.xiaochengdaren.com/2019092874249.jpg'), name: '', company: '梅州市梅江区华威贸易发展有限公司', content: '在梅州，有的人因为便利上下班通勤初衷买摩托，有人而为自身喜好买摩托，华威五羊本田提供各类摩托车型以及多样性、一体化摩托运动文化用品销售，满足各类用户需求，选择小城达人我们放心，协助商家共同分析营销痛点，结合用户需求，即时同城信息发布平台，信息分配至对应标签达人，实现精准投放，达到最佳产品推广效果，促成需求者消费，提升品牌知名度及用户购买信用度。'}
      ]
    }
  }
}
</script>
<style>
    .Tbox .Tmain{text-align:center;}
    .Tbox .Tmain .pic img{width: 100px;height:100px;border-radius:50%;}
    .Tbox .Tmain .name{font-size:16px;margin:10px 0;}
    .Tbox .Tmain .company{font-size:16px;margin-top:15px;}
    .Tbox .Tmain .content{background:url("https://img.xiaochengdaren.com/2019101039640.png") no-repeat;width: 820px;height:90px;overflow:hidden;padding:65px;margin:0 auto;font-size:14px;line-height:30px;color:#666;}
</style>
